exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.filter-bar[data-v-2e395e08]{\n  display: flex;\n  align-items: center;\n}\n.filter-item[data-v-2e395e08]{\n  width: 90%\n}\n.filter-item-checkbox[data-v-2e395e08]{\n  margin-left: 10px;\n}\n.filter-item + .filter-item[data-v-2e395e08]{\n  margin-left: 10px;\n}\n.filter-select[data-v-2e395e08]{\n  max-width: 14% !important;\n}\n.spacing[data-v-2e395e08]{\n  margin-left: 10px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2e395e08","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/People/PeopleFilters.vue
// module id = pWcd
// module chunks = 1